import React, { Component } from "react";
import {
  HelpBlock,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import { Auth } from "aws-amplify";
import LoaderButton from "../components/LoaderButton";
import ls from 'local-storage';
import "./Signup.css";

export default class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      confirmPassword: "",
      confirmationCode: "",
      newUser: false,
      signupFailed: null
    };
  }

  validateForm() {
    return (
      this.state.email.length > 0 &&
      this.getValidationState() === 'success' &&
      this.state.password === this.state.confirmPassword
    );
  }

  validateConfirmationForm() {
    return this.state.confirmationCode.length > 0;
  }

  getValidationState() {
    const length = this.state.password.length;
    if (length === 0) return null;
    if (length < 8) return 'error';
    if (!this.state.password.match(/[0-9]/g)) return 'error';
    if (!this.state.password.match(/[a-z]/g)) return 'error';
    if (!this.state.password.match(/[A-Z]/g)) return 'error';
    return 'success';
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    var userData = {
      username: this.state.email,
      password: this.state.password
    }

    if (ls.get("location")) {
      var location = {
        address: JSON.stringify(ls.get("location")),
        "custom:city_id": ls.get("location_id")
      }
      userData["attributes"] = location;
    }

    try {
      const newUser = await Auth.signUp(userData);
      this.setState({
        newUser
      });
    } catch (e) {
      this.setState({
        signupFailed: e.message
      })
    }

    this.setState({ isLoading: false });
  }

  handleConfirmationSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    try {
      await Auth.confirmSignUp(this.state.email, this.state.confirmationCode);
      await Auth.signIn(this.state.email, this.state.password);

      this.props.userHasAuthenticated(true);
      this.props.history.push("/");
    } catch (e) {
      // TODO: Improve
      alert(e.message);
      this.setState({ isLoading: false });
    }
  }

  renderConfirmationForm() {
    return (
      <form onSubmit={this.handleConfirmationSubmit} id="registration">
        <FormGroup controlId="confirmationCode" bsSize="large">
          <ControlLabel>Confirmation Code</ControlLabel>
          <FormControl
            autoFocus
            type="tel"
            value={this.state.confirmationCode}
            onChange={this.handleChange}
          />
          <HelpBlock>Please check your email for the code.</HelpBlock>
        </FormGroup>
        <LoaderButton
          block
          bsSize="large"
          disabled={!this.validateConfirmationForm()}
          type="submit"
          isLoading={this.state.isLoading}
          text="Verify"
          loadingText="Verifying…"
        />
      </form>
    );
  }

  renderForm() {
    return (
      <form onSubmit={this.handleSubmit}>
        <FormGroup controlId="email" bsSize="large">
          <ControlLabel>Email</ControlLabel>
          <FormControl
            autoFocus
            type="email"
            value={this.state.email}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="password" bsSize="large" validationState={this.getValidationState()}>
          <ControlLabel>Password</ControlLabel>
          <FormControl
            value={this.state.password}
            onChange={this.handleChange}
            type="password"
          />
          
        <FormControl.Feedback />
        <HelpBlock>At least 8 characters long.</HelpBlock>
          <HelpBlock>Contains at least 1 number.</HelpBlock>
          <HelpBlock>Contains at least 1 lowercase letter.</HelpBlock>
          <HelpBlock>Contains at least 1 uppercase letter.</HelpBlock>
        </FormGroup>
        <FormGroup controlId="confirmPassword" bsSize="large">
          <ControlLabel>Confirm Password</ControlLabel>
          <FormControl
            value={this.state.confirmPassword}
            onChange={this.handleChange}
            type="password"
          />
        </FormGroup>
        <LoaderButton
          block
          bsSize="large"
          disabled={!this.validateForm()}
          type="submit"
          isLoading={this.state.isLoading}
          text="Signup"
          loadingText="Signing up…"
        />
        {this.state.signupFailed &&
          <HelpBlock>{this.state.signupFailed}</HelpBlock>
          }
      </form>
    );
  }

  render() {
    return (
      <div className="Signup">
        {!this.state.newUser
          ? this.renderForm()
          : this.renderConfirmationForm()}
      </div>
    );
  }
}
